import companyApi from '@/modules/company/_api'
export default {
  computed: {
    officeId () {
      if (this.$store.getters['CompanyStore/currentCompany'] && this.$store.getters['CompanyStore/currentCompany'].id) {
        return this.$store.getters['CompanyStore/currentCompany'].id
      } else {
        return this.$store.getters['LoginStore/user'].office_id
      }
    },
    userOffice () {
      return this.$store.getters['CompanyStore/currentCompany'] && this.$store.getters['CompanyStore/currentCompany'].id ? this.$store.getters['CompanyStore/currentCompany'] : false
    },
    officeConfigurations () {
      return this.userOffice && this.userOffice.configs && this.userOffice.configs.length > 0 ? this.userOffice.configs : []
    },
    benefitsAccummulatedSettingStatus () {
      return this.officeConfigurations.find(el => el.code === 'FLEXIBLE_REMUNERATION_CUMULATIVE').config.activated || false
    }
  },
  methods: {
    generateConfiguration (configCode, configSetting) {
      let configuration = {
        code: configCode,
        config: { ...configSetting }

      }
      this.setOfficeConfiguration(configuration)
    },
    async setOfficeConfiguration (configuration) {
      if (!configuration || this.isSending) return
      let configurations = []
      if (configuration.length) {
        configurations = [...configuration]
      } else {
        configurations = [configuration]
      }

      try {
        this.isSending = true
        await companyApi.putOffice(this.officeId, { configs: configurations })
        await this.$store.dispatch('CompanyStore/fetchCompany', this.officeId)
        let userFilters = {
          'status.statusType.code': ['ACTIVE'],
          'roles': ['ROLE_REGULAR', 'ROLE_ADMIN']

        }
        this.$store.dispatch('UsersStore/setUsersFilters', { filters: userFilters })
        this.$store.dispatch('SnackBars/addSuccess', this.$i18n.t('benefits_office_setting_update_success'))
      } catch (error) {
        this.$store.dispatch('SnackBars/addErrorHandler', { error: error, errorMessage: 'benefits_office_setting_update_error' })
      } finally {
        this.isSending = false
      }
    }
    // TODO: To be removed, used to toggle ret flex accumulative status
    // async toggleAccumulativeStatus () {
    //   let accumulativeStatus = this.benefitsAccummulatedSettingStatus
    //   let newStatus = !accumulativeStatus
    //   this.generateConfiguration('FLEXIBLE_REMUNERATION_CUMULATIVE', { activated: newStatus })
    // }

  }
}
